export const handleAsyncAction = async ({ setLoading, setResult, fetcher }) => {
  setLoading(true);
  try {
    const result = await fetcher();
    setResult(result);
  } catch {
    setResult(null);
  } finally {
    setLoading(false);
  }
};
